import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { UploadHistory } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetMatterUploadHistory = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<UploadHistory[]>(
    [QueryEntity.UploadHistory, { matterId }],
    () => {
      return fetch(`${APIBaseChronos}/api/matter/${matterId}/upload-metadata/history`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
